import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Account, BankDetails } from '../../model/bankdetails';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { ErpTravelManagementCommonService } from '../../../shared/service/travelmanagementcommon.service';

@Component( {
    selector: 'erp-businesstripapplication-bankdetails',
    templateUrl: './businesstripapplication-bankdetails.component.html'
} )
export class BusinesstripApplicationBankdetailsComponent implements OnInit, OnChanges {
    @Input() bankDetails: BankDetails = new BankDetails();
    @Output() readonly bankDetailsChange: EventEmitter<BankDetails> = new EventEmitter<BankDetails>();

    private accounts: Account[] = [];
    accountSelected?: Account;
    bicSelected?: string;
    bicSuggestions: string[] = [];
    accountSuggestions: Account[] = [];

    constructor( private readonly erpTravelManagementCommonService: ErpTravelManagementCommonService ) { }

    ngOnChanges( changes: SimpleChanges ): void {
    }

    ngOnInit(): void {
        this.erpTravelManagementCommonService.getAccounts().subscribe( {
            complete: () => {
                this.accountSelected = this.accounts.find( ( account ) => account.accountIban === this.bankDetails.accountIban );
                this.bicSelected = this.accountSelected?.accountBic;
            },
            next: ( accounts: Account[] ) => {
                this.accounts = accounts;
            }
        } );
    };

    onModelChange( changedValue: number | boolean ) {
        if ( this.accountSelected ) {
            this.bankDetails.accountIban = this.accountSelected?.accountIban;
            this.bankDetails.accountBic = this.accountSelected?.accountBic;
        }
        this.bankDetailsChange.emit( this.bankDetails );
    }

    public resetBankDetailsChanges(): void {
        if ( this.bankDetails.changeBankDetails === false ) {
            this.bankDetails.changeAccountNewBic = undefined;
            this.bankDetails.changeAccountNewIban = undefined;
        }
    }

    filterAccountsToShow( event: AutoCompleteCompleteEvent ): void {
        let tempAccountsToShow: Account[] = [];
        this.accounts.forEach( ( account ) => {
            if ( this.bicSelected === undefined || this.bicSelected === '' || this.bicSelected === account.accountBic ) {
                tempAccountsToShow.push( account );
            }
        } );
        this.accountSuggestions = tempAccountsToShow;
    }

    filterBicsToShow( event: AutoCompleteCompleteEvent ): void {
        let tempBicsToShow: string[] = [];
        this.accounts.forEach( ( account ) => {
            if ( account.accountBic !== undefined && !tempBicsToShow.includes( account.accountBic ) ) {
                tempBicsToShow.push( account.accountBic );
            }
        } );
        this.bicSuggestions = tempBicsToShow;
    }

    onSelectIban( selectedAccount: Account ): void {
        this.bicSelected = this.accountSelected?.accountBic;
        this.accountSuggestions = [];
    }

    onSelectBic( selectedAccount: Account ): void {
        this.accountSelected = undefined;
    }
}
